import { ExportOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Form } from 'antd';
import { useState } from 'react';
import { EXPORT_TYPES, MODULES, TABLE_FILTER_KEYS } from '../../../../../common/constants';
import ExportDateRangeModal from '../../../../../components/ExportDateRangeModal';
import Portal from '../../../../../components/Portal';
import ResetFilterButton from '../../../../../components/ResetFilterButton';
import NewOrderTable from '../components/NewOrderTable';
import NewTabs from '../components/NewTabs';
import { REQUEST_NEW_ORDER_EXPORT_ADMIN } from '../graphql/Mutations';

const NewConfirmOrder = () => {
  const [form] = Form.useForm();
  const [exportFilter, setExportFilter] = useState();
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [requestNewOrderExportAdmin] = useMutation(
    REQUEST_NEW_ORDER_EXPORT_ADMIN,
    {
      onError: () => { },
    },
  );

  const handleExport = async (values) => {
    setIsExportLoading(true);
    const res = await requestNewOrderExportAdmin({
      variables: {
        data: {
          type: EXPORT_TYPES?.NEW_ORDERS,
        },
        filter: {
          search: exportFilter?.search,
          deliveryType: exportFilter?.deliveryType,
          orderTypes:
            exportFilter?.orderTypes?.length > 0
              ? exportFilter?.orderTypes
              : undefined,
          orderIds: exportFilter?.orderNumber,
          dateRange: {
            from: values?.date?.[0]?.startOf('day'),
            to: values?.date?.[1]?.endOf('day'),
          },
          deliveredOn: {
            from: exportFilter?.deliveredOn?.from?.$d,
            to: exportFilter?.deliveredOn?.to?.$d,
          },
          status:
            exportFilter?.status?.length > 0 ? exportFilter?.status : undefined,
          pincodeIds: exportFilter?.pincodes,
        },
      },
    });
    if (res?.data) {
      setIsModalOpen(false);
      form?.resetFields();
    }
    setIsExportLoading(false);
  };

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.CONFIRM_ORDER}</div>
      </Portal>
      <Portal portalId="header-right-content">
        <Button
          className="common-button ml-16"
          size="middle"
          icon={<ExportOutlined />}
          onClick={() => setIsModalOpen(true)}
          loading={isExportLoading}
        >
          Export
        </Button>
      </Portal>
      <Portal portalId="header-right-content-phones">
        <Button
          className="common-button ml-16"
          size="middle"
          icon={<ExportOutlined />}
          onClick={() => setIsModalOpen(true)}
          loading={isExportLoading}
        >
          Export
        </Button>
      </Portal>
      <ResetFilterButton tableKey={TABLE_FILTER_KEYS.NEW_ORDERS} />
      <ExportDateRangeModal
        form={form}
        onFinish={handleExport}
        loadings={isExportLoading}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
      <NewTabs>
        <div className="tab-table">
          <NewOrderTable
            exportFilter={exportFilter}
            setExportFilter={setExportFilter}
          />
        </div>
      </NewTabs>
    </>
  );
};

export default NewConfirmOrder;
